import { useNavigate } from "react-router-dom";
import { RouteConstants } from "../../constants";
import { useCompareService } from "../../services";
import { Heading, TypographyType, TypographyColor } from "../../ui-elements"
import { geoState, ptypeState } from "../../states";
import { useRecoilValue, useSetRecoilState } from "recoil";

interface AddToCompareProps {
    isAddedToCompare: boolean;
    geoId: number;
    level: number;
    parent_id: any;
    count: number;
    showNodeWithoutHover?: boolean;
    tooltipPosition: string;
    next?: (any?: any) => void;
    selectedItem?: any;
    geoLevel?: string;
}

export const AddToCompare: React.FC<AddToCompareProps> = ({ isAddedToCompare, geoId, level, count, parent_id=null, showNodeWithoutHover, tooltipPosition, next, selectedItem, geoLevel}) => {
    const navigate = useNavigate();
    const compareService = useCompareService();
    const setselectedGeo = useSetRecoilState(geoState);
    const pType = useRecoilValue(ptypeState);

    const handleCompareAction = async (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        e.stopPropagation();
        if (selectedItem) {
            const { geo_id, parent, grand_parent } = selectedItem;
            let selected: any = { country: 1 };
            if (grand_parent) {
                selected = { ...selected, state: grand_parent.geo_id, district: parent.geo_id, sub_district: geo_id };
            } else if (parent) {
                selected = { ...selected, state: parent.geo_id, district: geo_id };
            } else {
                selected = { ...selected, state: geo_id };
            }

            setselectedGeo(selected);
        }
        if (!isAddedToCompare) {
            if (count >= 9) return;
            const payload = {
                addToCompare: [{ geoId, level, ...(level === 5 && { parent_id }), pType: level === -1 && geoLevel ? geoLevel: level === -1 ? pType :  geoLevel ? geoLevel : pType === "RelationshipManager"? "Relationship Manager" : pType }]
            }
            await compareService.postCompreList(payload);
        } else {
            navigate(RouteConstants.compare);
        }
        next && next();
    }   
    
    return (
        <span className="d-flex justify-content-center align-items-center compare position-relative pe-auto" onClick={(e) => handleCompareAction(e)}>
            {isAddedToCompare ? (
                <span className="d-flex align-items-center justify-content-end m-0 p-0">
                    <Heading
                        title="✓&nbsp;"
                        type={TypographyType.h7}
                        colour={TypographyColor.primary}
                        classname={`text-start add-to-compare text-nowrap ${showNodeWithoutHover ? 'visible' : ''}`}
                    />
                    <Heading
                        title=" View comparisons"
                        type={TypographyType.h7}
                        colour={TypographyColor.primary}
                        classname={`text-end text-underline add-to-compare text-nowrap ${showNodeWithoutHover ? 'visible' : ''}`}
                    />
                </span>
            ) : (
                <span className="d-flex align-items-center justify-content-end m-0 p-0">
                    <Heading
                        title="+&nbsp;"
                        type={TypographyType.h7}
                        colour={TypographyColor.primary}
                        classname={`text-start add-to-compare text-nowrap ${showNodeWithoutHover ? 'visible' : ''} ${count >= 9 ? "disabled-heading cursor-default" : ""}`}
                    />
                    <Heading
                        title="Add to compare"
                        type={TypographyType.h7}
                        colour={TypographyColor.primary}
                        classname={`text-end text-underline add-to-compare text-nowrap ${showNodeWithoutHover ? 'visible' : ''} ${count >= 9 ? "disabled-heading cursor-default pe-none" : ""}`}
                    />
                </span>
            )}
            {count >= 9 && !isAddedToCompare &&
                <div className={`compare-tooltip position-absolute bg-white rounded ${tooltipPosition}`}>
                    <Heading
                        title='You have reached the limit of 9 regions. Remove some to add more.'
                        type={TypographyType.h6}
                        colour={TypographyColor.secondary}
                        classname='text-start padding-2'
                    />
                </div>
            }
        </span>
    )
}